export const emailConstants = {
    
    GET_EMAIL_SETTINGS_LIST_REQUEST: "FETCH_EMAIL_SETTINGS_LIST_REQUEST",
    GET_EMAIL_SETTINGS_LIST_SUCCESS: "FETCH_EMAIL_SETTINGS_LIST_SUCCESS",
    GET_EMAIL_SETTINGS_LIST_FAILURE: "FETCH_EMAIL_SETTINGS_LIST_FAILURE",

    GET_ACTIVE_EMAIL_SETTINGS_LIST_REQUEST: "GET_ACTIVE_EMAIL_SETTINGS_LIST_REQUEST",
    GET_ACTIVE_EMAIL_SETTINGS_LIST_SUCCESS: "GET_ACTIVE_EMAIL_SETTINGS_LIST_SUCCESS",
    GET_ACTIVE_EMAIL_SETTINGS_LIST_FAILURE: "GET_ACTIVE_EMAIL_SETTINGS_LIST_FAILURE",

    POST_EMAIL_SETTINGS_LIST_REQUEST: "POST_EMAIL_SETTINGS_LIST_REQUEST",
    POST_EMAIL_SETTINGS_LIST_SUCCESS: "POST_EMAIL_SETTINGS_LIST_SUCCESS",
    POST_EMAIL_SETTINGS_LIST_FAILURE: "POST_EMAIL_SETTINGS_LIST_FAILURE",
  
}  